import List from "./List";

export default {
  List,
};

export { default as List } from "./List";
